export default "__VITE_ASSET__18dc5d0a__"